// extracted by mini-css-extract-plugin
module.exports = {"BreakToast":"Toast_BreakToast__1gxOi"};